import Vue from 'vue'
import Router from 'vue-router'
//import store from '@/store/index'
import Home from '../views/Home.vue'
import authentication from '../authentication'

Vue.use(Router)

const router = new Router({
    base: __dirname,
    mode: 'history',
    routes: [{
        path: '/',
        name: 'Home',
        component: Home,

    },
    {
        path: '/vendors',
        name: 'Vendor Information',
        component: () => import(/* webpackPrefetch: true */'@/views/Vendors.vue'),
        meta: {
            requiresAuthentication: true
        }
    },
    {
        path: '/mfg-prefix',
        name: 'Manufacturer Price List',
        component: () => import(/* webpackPrefetch: true */'@/views/Pdf-View.vue'),
        props: { sourceUrl: '/mfg%20prefixes.pdf',filename:'mfg prefixes.pdf' },
        meta: {
            requiresAuthentication: true
        }
    },
    {
        path: '/profile',
        name: 'User Profile',
        component: () => import(/* webpackPrefetch: true */'@/views/Profile.vue'),
        meta: {
            requiresAuthentication: true
        }
    }]
})

// router.beforeEach((to, from, next) => {
//     if (to.matched.some(record => record.meta.requiresAuthentication)) {
//         // this route requires auth, check if logged in
//         if (authentication.isAuthenticated()) {
//             // only proceed if authenticated.
//             next();
//         } else {
//             authentication.signIn();
//         }
//     } else {
//         next();
//     }
// });

export default router